export default __webpack_public_path__ + "beta-maps-guides-migrate-3d-model-960-3916b3b74424de00e57135ae5d641f61.webp";